import React, { PureComponent } from 'react';
import range from 'lodash/range';
import Modal from '../../../../components/Modal';
import { Form, FormGroup, SubmitButton, FormError } from '../../../../components/Forms/Forms';
import { Input, Select, Textarea } from '../../../../components/Forms/fields/index';
import rules from '../../../../components/Forms/rules';
import enums from '../../../../constants/enums';

class CreatePaymentView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      defaultTypeValue: '',
    }
  }
  render() {
    const {
      closeCreateModal,
      createModalActive,
      formState,
      submitForm,
      onFormUpdate,
      addRow,
      removeRow,
      buyOffers,
      amazonAccounts,
    } = this.props;
    // from, to, amountFrom, amountTo, currencyFrom, currencyTo, description

    return (
      <Modal active={createModalActive} onClose={closeCreateModal}>
        <h3>Create Payment</h3>
        <div className="payment-create-form">
          <div className="actions-bar">
            <div className="form-group">
              <label>Default Type:</label>
              <select
                value={this.state.defaultTypeValue}
                onChange={(e) => {
                  this.setState({
                    defaultTypeValue: e.target.value,
                  })
                }}
              >
                <option value="">...</option>
                {buyOffers.map((offer, i)=>(
                  <option key={i} value={offer.payment_method_name}>{offer.payment_method_name}</option>
                ))}

              </select>
            </div>

            <button type="button" className="button" onClick={addRow}>+</button>
          </div>
          <Form state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
            <table>
              <thead>
              <tr>
                <th>Type</th>
                <th>Status</th>
                <th>Code</th>
                <th>Pin</th>
                <th>Value</th>
                <th>Order #</th>
                <th>Account</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              {formState.data.payments.map((payment, i)=>(
                <tr key={i}>
                  <td>
                    <FormGroup>
                      <Select
                        name={`payments[${i}].type`}
                        options={buyOffers.map(offer => offer.payment_method_name)}
                        defaultValue={this.state.defaultTypeValue}
                      />
                      <FormError/>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Select
                        name={`payments[${i}].status`}
                        options={enums.paymentStatus}
                        defaultValue={'verified'}
                      />
                      <FormError/>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input name={`payments[${i}].code`} type="text" validate={[rules.required()]}/>
                      <FormError/>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input name={`payments[${i}].pin`} type="text"/>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input name={`payments[${i}].value`} type="number" validate={[rules.required()]}/>
                      <FormError/>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input name={`payments[${i}].orderNumber`} type="text" />
                      <FormError/>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Select name={`payments[${i}].account`} options={amazonAccounts} emptyOption />
                      <FormError/>
                    </FormGroup>
                  </td>

                  <td>
                    <button type="button" className="button" onClick={() => removeRow(i)}>-</button>
                  </td>

                </tr>
              ))}
              </tbody>
            </table>


            {formState.data.payments.length > 0 && (
              <div className="actions">
                <button type="submit" className="button">Create</button>
              </div>
            )}
          </Form>
        </div>
      </Modal>
    )
  }
}

export default CreatePaymentView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/CreatePayment/CreatePayment.view.js